var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/retry.36d198f5.png","uri@3x": __webpack_public_path__ + "static/media/retry.774309f7.png","uri@2x": __webpack_public_path__ + "static/media/retry.29ad112f.png",
    width: 10,
    height: 10
});